<template>
  <div class="data-screen">
    <!-- 头部 -->
    <header class="screen-header animate__animated animate__fadeInDown">
      <div class="header-left">
        <i class="el-icon-monitor back-icon" @click="$router.push('/main')" title="返回首页"></i>
      </div>
      <h1 class="header-title">广告流量变现智慧数字大屏</h1>
      <div class="header-right">
        <div class="time-display animate__animated animate__pulse animate__infinite">
          <span class="time-value">{{ currentTimeString }}</span>
        </div>
      </div>
    </header>

    <div class="screen-container">
      <!-- 左侧列 -->
      <aside class="left-column animate__animated animate__fadeInLeft">
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">今日广告记录条数</div>
          <div class="statistic-content">
            <i class="el-icon-document statistic-icon"></i>
            <span class="digit-value">{{ todayAdCount }}</span>
            <span class="unit">条</span>
          </div>
        </div>
        
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">近一个月总收益</div>
          <div class="statistic-content">
            <i class="el-icon-money statistic-icon"></i>
            <span class="digit-value">¥{{ monthTotalEcpm }}</span>
          </div>
        </div>
        
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">用户分析</div>
          <div class="user-stats-container">
            <div class="user-stat-item">
              <i class="el-icon-user statistic-icon today"></i>
              <div class="stat-info">
                <p class="label">今日活跃</p>
                <p class="val today">{{ todayActiveUsers }}</p>
              </div>
            </div>
            <div class="user-stat-item">
              <i class="el-icon-user-solid statistic-icon yesterday"></i>
              <div class="stat-info">
                <p class="label">昨日活跃</p>
                <p class="val">{{ yesterdayActiveUsers }}</p>
              </div>
            </div>
            <div class="user-stat-item">
              <i class="el-icon-s-custom statistic-icon total"></i>
              <div class="stat-info">
                <p class="label">累计用户</p>
                <p class="val total">{{ totalUsers }}</p>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <!-- 中间列 -->
      <main class="center-column animate__animated animate__fadeInUp">
        <div class="center-main-card">
          <h2 class="main-title">今日总收益</h2>
          <div class="digital-display">
            <span class="currency">¥</span>
            <div class="digit-box animate__animated animate__bounceIn" v-for="(digit, index) in incomeDigits" :key="index" :style="{ animationDelay: (index * 0.1) + 's' }">{{ digit }}</div>
          </div>
        </div>

        <div class="chart-card main-chart-card animate__animated animate__fadeInUp animate__delay-1s">
          <div class="card-header-actions">
            <div class="card-title">{{ chartTitle }}</div>
            <el-button-group class="chart-toggle">
              <el-button 
                size="mini" 
                :type="currentView === 'hourly' ? 'primary' : ''"
                @click="switchToHourlyView"
                :loading="hourlyDataLoading"
                icon="el-icon-time"
              >
                近 24 小时
              </el-button>
              <el-button 
                size="mini" 
                :type="currentView === 'daily' ? 'primary' : ''"
                @click="switchToDailyView"
                :loading="dailyDataLoading"
                icon="el-icon-date"
              >
                近一周
              </el-button>
            </el-button-group>
          </div>
          <div id="revenueChart" class="chart-box" ref="revenueChart"></div>
        </div>
      </main>

      <!-- 右侧列 -->
      <aside class="right-column animate__animated animate__fadeInRight">
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">团长人数</div>
          <div class="statistic-content">
            <i class="el-icon-s-management statistic-icon"></i>
            <span class="digit-value">{{ teamLeaderCount }}</span>
            <span class="unit">人</span>
          </div>
        </div>
        
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">累计提现</div>
          <div class="statistic-content">
            <i class="el-icon-wallet statistic-icon"></i>
            <span class="digit-value">¥{{ totalWithdrawals }}</span>
          </div>
        </div>
        
        <div class="chart-card animate__animated animate__zoomIn animate__delay-1s">
          <div class="card-title">今日提现</div>
          <div class="statistic-content">
            <i class="el-icon-money statistic-icon"></i>
            <span class="digit-value">¥{{ todayWithdrawals }}</span>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>
<script>
import { get } from '@/utils/http';
import * as echarts from 'echarts';

export default {
  name: 'DataDashboard',
  data() {
    return {
      todayAdCount: 0,
      monthTotalEcpm: '0.00',
      todayTotalEcpm: '0.00',
      todayActiveUsers: 0,
      yesterdayActiveUsers: 0,
      totalUsers: 0,
      hourlyRevenueData: [],
      dailyRevenueData: [],
      currentView: 'hourly',
      revenueChart: null,
      currentTimeString: '',
      hourlyDataLoading: false,
      dailyDataLoading: false,
      teamLeaderCount: 0,
      totalWithdrawals: '0.00',
      todayWithdrawals: '0.00',
      incomeDigits: []
    };
  },
  computed: {
    chartTitle() {
      return this.currentView === 'hourly' ? '近 24 小时收益分布' : '近一周每日收益趋势';
    }
  },
  async mounted() {
    this.initAnimations();
    await this.fetchDashboardStatistics();
    await this.fetchTeamLeaderCount();
    await this.fetchTotalWithdrawals();
    await this.fetchTodayWithdrawals();
    await this.fetchHourlyRevenueData();
    this.updateCurrentTime();
    setInterval(() => {
      this.updateCurrentTime();
    }, 1000);
    this.$nextTick(() => {
      this.initChart();
      this.updateChart();
    });
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    initAnimations() {
      const head = document.head;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
      head.appendChild(link);
    },
    async fetchDashboardStatistics() {
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getDashboardStatistics');
        
        if (response.data) {
          const data = response.data;
          
          // 注意：后端字段名没有空格
          this.todayAdCount = data['今日广告记录条数'] || 0;
          this.monthTotalEcpm = data['近一个月总ecpm'] || 0;
          this.todayActiveUsers = data['今日活跃用户数'] || 0;
          this.yesterdayActiveUsers = data['昨日活跃用户数'] || 0;
          this.totalUsers = data['累计用户'] || 0;
          
          // 今日总收益按字符分割显示
          const todayEcpm = data['今日总ecpm'] || 0;
          const revenueStr = todayEcpm.toString();
          this.incomeDigits = revenueStr.split('');
        }
      } catch (error) {
        console.error('获取数据大屏统计信息失败:', error.message);
        // 后端错误，显示友好提示，使用默认值
        this.$message.error('获取数据失败，部分数据可能无法正常显示');
        // 设置默认值，避免页面显示异常
        this.todayAdCount = 0;
        this.monthTotalEcpm = 0;
        this.todayActiveUsers = 0;
        this.yesterdayActiveUsers = 0;
        this.totalUsers = 0;
        this.incomeDigits = ['0'];
      }
    },
    async fetchTeamLeaderCount() {
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getTeamLeaderCount');
        if (response.data) {
          this.teamLeaderCount = response.data || 0;
        }
      } catch (error) {
        console.error('获取团长人数失败:', error.message);
      }
    },
    async fetchTotalWithdrawals() {
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getTotalWithdrawals');
        if (response.data) {
          this.totalWithdrawals = (response.data || 0).toFixed(2);
        }
      } catch (error) {
        console.error('获取累计提现失败:', error.message);
      }
    },
    async fetchTodayWithdrawals() {
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getTodayWithdrawals');
        if (response.data) {
          this.todayWithdrawals = (response.data || 0).toFixed(2);
        }
      } catch (error) {
        console.error('获取今日提现失败:', error.message);
      }
    },
    async fetchHourlyRevenueData() {
      this.hourlyDataLoading = true;
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getHourlyRevenueForLast24Hours');
        if (response.data) {
          this.hourlyRevenueData = response.data;
          if (this.currentView === 'hourly') {
            this.$nextTick(() => {
              this.updateChart();
            });
          }
        }
      } catch (error) {
        console.error('获取小时收益数据失败:', error.message);
        this.$message.error('获取小时收益数据失败：' + error.message);
      } finally {
        this.hourlyDataLoading = false;
      }
    },
    async fetchDailyRevenueData() {
      this.dailyDataLoading = true;
      try {
        const response = await get('/admin/ADRevenueDataAdmin/getDailyRevenueForLastWeek');
        if (response.data) {
          this.dailyRevenueData = response.data;
          if (this.currentView === 'daily') {
            this.$nextTick(() => {
              this.updateChart();
            });
          }
        }
      } catch (error) {
        console.error('获取每日收益数据失败:', error.message);
        this.$message.error('获取每日收益数据失败：' + error.message);
      } finally {
        this.dailyDataLoading = false;
      }
    },
    initChart() {
      if (!this.revenueChart) {
        this.revenueChart = echarts.init(this.$refs.revenueChart);
      }
    },
    updateChart() {
      if (!this.revenueChart) return;

      let dates = [];
      let values = [];

      if (this.currentView === 'hourly') {
        const hourlyData = this.hourlyRevenueData || [];
        dates = hourlyData.map(item => item.hour);
        values = hourlyData.map(item => parseFloat(item.total_ecpm) || 0);
      } else {
        const dailyData = this.dailyRevenueData || [];
        dates = dailyData.map(item => item.date);
        values = dailyData.map(item => parseFloat(item.total_ecpm) || 0);
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>收益：¥{c}',
          backgroundColor: 'rgba(13, 42, 90, 0.8)',
          borderColor: '#00e4ff',
          textStyle: { color: '#fff' }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: { color: '#a5b6d4', fontSize: 11, rotate: 45 },
          axisLine: { lineStyle: { color: '#1a3c7a' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: { formatter: '¥{value}', color: '#a5b6d4', fontSize: 11 },
          axisLine: { lineStyle: { color: '#1a3c7a' } },
          splitLine: { lineStyle: { color: '#1a3c7a', type: 'dashed' } }
        },
        series: [{
          name: '收益',
          data: values,
          type: 'line',
          smooth: true,
          symbolSize: 6,
          itemStyle: { color: '#00e4ff' },
          lineStyle: { color: '#00e4ff', width: 3 },
          areaStyle: {
            opacity: 0.3,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0, 228, 255, 0.5)' },
              { offset: 1, color: 'rgba(0, 228, 255, 0.1)' }
            ])
          }
        }]
      };

      this.revenueChart.setOption(option);
    },
    async switchToHourlyView() {
      if (this.currentView !== 'hourly') {
        this.currentView = 'hourly';
        await this.fetchHourlyRevenueData();
        this.$nextTick(() => {
          this.updateChart();
        });
      } else {
        await this.fetchHourlyRevenueData();
      }
      this.updateCurrentTime();
    },
    async switchToDailyView() {
      if (this.currentView !== 'daily') {
        this.currentView = 'daily';
        await this.fetchDailyRevenueData();
        this.$nextTick(() => {
          this.updateChart();
        });
      } else {
        await this.fetchDailyRevenueData();
      }
      this.updateCurrentTime();
    },
    updateCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');
      this.currentTimeString = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    handleResize() {
      if (this.revenueChart) {
        this.revenueChart.resize();
      }
    }
  },
  beforeDestroy() {
    if (this.revenueChart) {
      this.revenueChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.data-screen {
  width: 100%;
  height: 100vh;
  background-color: #030829;
  color: #fff;
  font-family: "Microsoft YaHei", sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.screen-header {
  height: 80px;
  background: linear-gradient(to bottom, rgba(24, 144, 255, 0.2), transparent);
  border-bottom: 2px solid #1a3c7a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.header-left .back-icon {
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s;
}

.header-left .back-icon:hover {
  color: #409EFF;
  transform: scale(1.1);
}

.header-title {
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 4px;
  background: linear-gradient(to bottom, #fff, #4a90e2);
  -webkit-background-clip: text;
  color: transparent;
  margin: 0;
}

.time-display {
  background: rgba(13, 42, 90, 0.8);
  padding: 8px 15px;
  border-radius: 4px;
  border: 1px solid #1890ff;
}

.time-value {
  color: #00e4ff;
  font-family: 'Courier New', Courier, monospace;
  font-size: 18px;
  font-weight: bold;
}

.screen-container {
  flex: 1;
  display: flex;
  padding: 1% 20px;
  gap: 20px;
  overflow: hidden;
  height: 0;
}

.left-column {
  flex: 3 1 0;
  display: flex;
  flex-direction: column;
  gap: 1.5%;
  height: 100%;
  min-width: 0;
}

.center-column {
  flex: 7 1 0;
  display: flex;
  flex-direction: column;
  gap: 1.5%;
  height: 100%;
  min-width: 0;
}

.chart-card {
  flex: 1 1 0;
  background: rgba(16, 32, 74, 0.8);
  border: 1px solid #1a3c7a;
  padding: 1% 15px;
  border-radius: 8px;
  box-shadow: inset 0 0 15px rgba(24, 144, 255, 0.2);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.main-chart-card {
  flex: 2.5 1 0;
  min-height: 0;
}

.card-title {
  font-size: 0.9vw;
  font-weight: bold;
  padding-left: 10px;
  border-left: 4px solid #1890ff;
  margin-bottom: 1%;
  color: #fff;
  flex-shrink: 0;
}

.card-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1%;
  flex-shrink: 0;
}

.card-header-actions .card-title {
  margin-bottom: 0;
}

.statistic-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vw;
  min-height: 0;
}

.statistic-icon {
  font-size: 2vw;
  color: #1890ff;
  background: rgba(24, 144, 255, 0.1);
  width: 3.5vw;
  height: 3.5vw;
  line-height: 3.5vw;
  text-align: center;
  border-radius: 50%;
  flex-shrink: 0;
}

.digit-value {
  font-size: 1.8vw;
  font-weight: bold;
  color: #00e4ff;
  font-family: 'Arial';
}

.unit {
  font-size: 0.8vw;
  color: #a5b6d4;
  margin-top: 0.5vw;
}

.user-stats-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
  min-height: 0;
  padding: 10px 0;
}

.user-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: rgba(24, 144, 255, 0.05);
  padding: 15px 10px;
  border-radius: 6px;
  flex: 1;
  min-width: 0;
}

.statistic-icon.today { color: #00e4ff; background: rgba(0, 228, 255, 0.1); }
.statistic-icon.yesterday { color: #a5b6d4; background: rgba(165, 182, 212, 0.1); }
.statistic-icon.total { color: #67c23a; background: rgba(103, 194, 58, 0.1); }
.statistic-icon.total { color: #67c23a; background: rgba(103, 194, 58, 0.1); }

.stat-info .label {
  font-size: 0.7vw;
  color: #a5b6d4;
  margin: 0;
  text-align: center;
  white-space: nowrap;
}

.stat-info .val {
  font-size: 1.2vw;
  font-weight: bold;
  margin: 5px 0 0 0;
  text-align: center;
}

.center-main-card {
  background: rgba(16, 32, 74, 0.8);
  border: 1px solid #1a3c7a;
  border-radius: 8px;
  padding: 2% 15px;
  text-align: center;
  box-shadow: inset 0 0 15px rgba(24, 144, 255, 0.2);
  margin-bottom: 1.5%;
  flex-shrink: 0;
}

.main-title {
  font-size: 1.2vw;
  font-weight: bold;
  color: #fff;
  margin: 0 0 1% 0;
  letter-spacing: 2px;
}

.digital-display {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5vw;
}

.currency {
  font-size: 1.5vw;
  color: #00e4ff;
  font-weight: bold;
}

.digit-box {
  width: 3vw;
  height: 4vw;
  background: rgba(0, 228, 255, 0.1);
  border: 2px solid #00e4ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2vw;
  font-weight: bold;
  color: #00e4ff;
  font-family: 'Arial', sans-serif;
  box-shadow: 0 0 10px rgba(0, 228, 255, 0.3);
}

.right-column {
  flex: 3 1 0;
  display: flex;
  flex-direction: column;
  gap: 1.5%;
  height: 100%;
  min-width: 0;
}

.right-column {
  flex: 3 1 0;
  display: flex;
  flex-direction: column;
  gap: 1.5%;
  height: 100%;
  min-width: 0;
}

.chart-box {
  width: 100%;
  height: 100%;
  min-height: 0;
}
</style>
